import { OpenInNew } from '@mui/icons-material';
import {
  Link,
  LinkProps,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemProps,
  ListItemText,
} from '@mui/material';
import React from 'react';

type LinkItemProps = ListItemProps &
  LinkProps & {
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    showLinkIcon?: boolean;
    textColor?: string;
    isButton?: boolean;
  };

export const LinkItem = ({
  leftIcon,
  children,
  textColor,
  rightIcon,
  showLinkIcon = true,
  isButton = false,
  ...restProps
}: LinkItemProps) => {
  const content = (
    <>
      {leftIcon && <ListItemIcon className="link-item__icon">{leftIcon}</ListItemIcon>}
      <ListItemText
        className="link-item__text"
        primary={children}
        primaryTypographyProps={{
          variant: 'callout',
          color: textColor || 'text.primary',
          textTransform: 'capitalize',
        }}
      />
      {rightIcon && (
        <ListItemIcon sx={{ marginX: 1 }} className="link-item__right-icon">
          {rightIcon}
        </ListItemIcon>
      )}
      {showLinkIcon && (
        <OpenInNew
          className="link-item__external-icon"
          color="primary"
          sx={{ fontSize: 16, marginX: 1 }}
        />
      )}
    </>
  );

  if (isButton) {
    return (
      <ListItemButton
        className="link-item"
        sx={{
          cursor: restProps?.onClick || restProps?.href ? 'pointer' : 'default',
          width: 'fit-content',
        }}
        component={Link}
        target="_blank"
        {...restProps}
        rel="noopener noreferrer"
      >
        {content}
      </ListItemButton>
    );
  }

  return (
    <ListItem
      className="link-item"
      sx={{
        cursor: restProps?.onClick || restProps?.href ? 'pointer' : 'default',
        width: 'fit-content',
      }}
      component={Link}
      target="_blank"
      {...restProps}
      rel="noopener noreferrer"
    >
      {content}
    </ListItem>
  );
};
